import { useCallback } from "react"
import { graphql, UseMutationConfig } from "react-relay"
import { type CustomMutationParams, useMutationWithErrorDialog } from "@/hooks/useMutationWithErrorDialog"
import {
  De_generateAttestationGuardianDocumentInput,
  useDeGenerateLegalGuardianAttestationDocumentMutation as useDeGenerateLegalGuardianAttestationDocumentMutationType,
} from "@/modules/patients/detail/legal-guardian-attestation/de/services/__generated__/useDeGenerateLegalGuardianAttestationDocumentMutation.graphql"
import { usePatientParam } from "@/modules/patients/hooks/usePatientParam"

const mutation = graphql`
  mutation useDeGenerateLegalGuardianAttestationDocumentMutation($input: De_generateAttestationGuardianDocumentInput!) {
    de_generateAttestationGuardianDocument(input: $input) {
      de_AttestationGuardian {
        id
        fileId
        ...deLegalGuardianAttestationFragment
      }
      errors {
        ... on Error {
          message
        }
      }
    }
  }
`

type Config = Omit<UseMutationConfig<useDeGenerateLegalGuardianAttestationDocumentMutationType>, "variables"> & {
  params: Pick<De_generateAttestationGuardianDocumentInput, "id">
}

const useDeGenerateLegalGuardianAttestationDocumentMutation = (params?: CustomMutationParams) => {
  const [commit, isFlight] = useMutationWithErrorDialog<useDeGenerateLegalGuardianAttestationDocumentMutationType>(
    mutation,
    params,
  )

  const patientById = usePatientParam()

  const commitHandler = useCallback(
    (config: Config) => {
      commit({
        variables: {
          input: { patientId: patientById, id: config.params.id },
        },
        ...config,
      })
    },
    [commit, patientById],
  )

  return [commitHandler, isFlight] as const
}

export { useDeGenerateLegalGuardianAttestationDocumentMutation }
